
/// <reference path="../../../../setup/_references.ts" />
module onvio.clientDashboard.ClientRelatedContactsItemComponent {
    'use strict';

    export class ClientRelatedContactsItemController {
        public contact: cs.IContactWithExpansionV7Dto;
        public subString: string;
        public onEdit: (contact: cs.IContactWithExpansionV7Dto) => void;
    }

    export class ClientRelatedContactsItemComponent implements ng.IComponentOptions {
        bindings: any = {
            contact: '<',
            subString: '@',
            onEdit: '&'
        };
        controller = ClientRelatedContactsItemController;
        templateUrl = 'client-dashboard/components/client-related-contacts-component/client-related-contacts-item-component/client-related-contacts-item-component.html';
    }

    angular.module('onvio.clientDashboard.ClientRelatedContactsItemComponent', ['bmProfilePhoto'])
            .component('clientRelatedContactsItem', new ClientRelatedContactsItemComponent());
}
